import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Checkbox,
    FormGroup,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    MenuItem,
    Paper,
    Typography,
} from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from "@material-ui/core/styles";
import { ValidatorForm, SelectValidator, TextValidator } from "react-material-ui-form-validator";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { CboProfesionales } from '../../../cbos/CboProfesionales';
import { CboCentrosMedicos } from '../../../cbos/CboCentrosMedicos';
import { CboEspecialidades } from '../../../cbos/CboEspecialidades';
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useForm } from "../../../../hooks/useForm";
import moment from "moment";
import { agregarEfectorHorario, efectorHorariosLimpiar, efectorHorariosUpdateDisabled, fetchEfectorHorarios, modificarPisoConsultorio } from '../../../../actions/turnos/efectorHorarios';
import { CboFrecuencia } from '../../../cbos/CboFrecuencia';
import { CboFrecuenciaAlcance } from '../../../cbos/CboFrecuenciaAlcance';
import { ListaParametrizacion } from './ListaParametrizacion';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../../utils/permisos';
import { TIPO_PARAMETRIZACION_TURNOS, diasSemana } from '../../../../utils/constants';
import { callConParametrosTurnos } from '../../../../helpers/extraFunctions';
import { ModalEquilvalenciaOspe } from './ModalEquivalenciaOspe';
import { getAbmUsuarioPorIdProfesional, limpiarAbmUsuarioPorIdProfesional } from '../../../../actions/turnos/abmUsuarioPorIdProfesional';

import { ModalAgregarPracticas } from './ModalAgregarPracticas';
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import { startAlerta } from '../../../../actions/ui/alertas';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
    },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    },
    button: {
        marginLeft: 25,
    },
    buttonActualizar: {
        marginLeft: 25,
    }
}));

const getIteration = (max, min, qtyIteration) => {
    for (var d = [], i = min; i <= max; i += qtyIteration) {
        d.push(i);
    }
    return d;
}

const horas = getIteration(23, 0, 1);
const minutos = getIteration(59, 0, 5);
const duraciones = getIteration(60, 5, 5);
const cantSobreTurnosIteracion = getIteration(10, 0, 1);

const stateInitial = {
    idEfHorario: 0,
    idProf: '',
    presencial: true,
    virtual: true,
    demanda: false,
    idFrecuencia: '',
    idAlcanceFrecuencia: '',
    horaDesde: '',
    minDesde: '',
    horaHasta: '',
    minHasta: '',
    duracion: '',
    cantSobreTurnos: 0,
    fechaInicio: '',
    fechaFin: '',
    consultorio: '',
    piso: '',
    edadMaxima: '',
    edadMinima: '',
    recepcion: null
}

export const HomeParametrizacionHorarios = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [idEspecialidad, setIdEspecialidad] = useState(null);
    const [idCentroMedico, setIdCentroMedico] = useState(null);
    const [idProfesional, setIdProfesional] = useState(null);
    //Agregado
    const [editRegistro, setEditRegistro] = useState(false);
    const [open, setOpen] = useState(false);
    const [formValues, handleInputChange, reset, setearValor, , , , , setearVariosValores] = useForm(stateInitial);
    const { idEfHorario, presencial, virtual, demanda, idFrecuencia, idAlcanceFrecuencia, horaDesde, minDesde, horaHasta, minHasta, duracion, cantSobreTurnos, fechaInicio, fechaFin, consultorio, piso, edadMaxima, edadMinima, idProf, recepcion } = (formValues);
    const [selectedDays, setSelectedDays] = useState(['LU', 'MA', 'MI', 'JU', 'VI']);
    const [editarPisoConsultorio, setEditarPisoConsultorio] = useState(false);
    const [botonActualizar, setBotonActualizar] = useState(false);

    const { items, cargada } = useSelector((state) => state.efectorHorarios);
    const { disabled } = useSelector((state) => state.efectorHorarios);
    const { permisos: permisosUser } = useSelector(state => state.auth)

    //AGREGADO
    const [openAlta, setOpenAlta] = useState(false);
    const { usuario } = useSelector((state) => state.abmUsuarioPorIdProfesional);



    const errorModalidad = (!presencial && !virtual);
    const errorDias = ((selectedDays.length === 0) || (editRegistro && selectedDays.length > 1));
    const errorHorario = ((horaHasta && horaDesde && horaDesde > horaHasta) || (horaDesde && horaHasta && horaHasta < horaDesde));

    useEffect(() => {
        dispatch(efectorHorariosLimpiar());
        dispatch(efectorHorariosUpdateDisabled(true));
    }, [dispatch]);

    useEffect(() => {
        dispatch(efectorHorariosUpdateDisabled(true));
    }, [dispatch, idCentroMedico, idProfesional, idEspecialidad]);

    const handleInputChangeCascada = ({ target }) => {
        switch (target.name) {
            case 'idCentroMedico':
                setIdCentroMedico(target.value);
                setIdProfesional(null);
                setIdEspecialidad(null);
                break;
            case 'idProfesional':
                if (target.value === '') {
                    setIdProfesional(null);
                }
                else {
                    setIdProfesional(target.value);
                    setIdEspecialidad(null);
                }
                break;
            case 'idEspecialidad':
                setIdEspecialidad(target.value);
                break;
            default:
                break;
        }
        editRegistro && reset(stateInitial);
        dispatch(efectorHorariosLimpiar());
    }

    //AGREGADO

    useEffect(() => {
        dispatch(limpiarAbmUsuarioPorIdProfesional());
        if (idProfesional !== null)
            dispatch(getAbmUsuarioPorIdProfesional(idProfesional));
    }, [dispatch, idProfesional]);




    const handleChangeDemanda = (e) => {
        if (e.target.checked)
            setearVariosValores({ ...formValues, demanda: true, presencial: true, virtual: false });
        else
            setearValor(e.target.name, e.target.checked);
    }

    const handleClick = (dia) => {
        const selectedIndex = selectedDays.indexOf(dia.value);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedDays, dia.value);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedDays.slice(1));
        } else if (selectedIndex === selectedDays.length - 1) {
            newSelected = newSelected.concat(selectedDays.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedDays.slice(0, selectedIndex),
                selectedDays.slice(selectedIndex + 1)
            );
        }
        setSelectedDays(newSelected);
    };

    const handleSearch = () => {
        dispatch(efectorHorariosUpdateDisabled(true));
        idEspecialidad && dispatch(fetchEfectorHorarios(idCentroMedico, idProfesional, idEspecialidad, TIPO_PARAMETRIZACION_TURNOS.NORMAL));
    }

    const handleCopyItem = (item) => {
        if(disabled)
            return dispatch(startAlerta('Item deshabilitado para copiar.', "warning", `¡Atención!`));

        setearVariosValores(
            { 
                ...formValues, 
                cantSobreTurnos: item.cantSobreTurnos, 
                consultorio: item.consultorio,
                demanda: item.demanda,
                duracion: item.duracion,
                edadMaxima: item.edadMaxima,
                edadMinima: item.edadMinima,
                horaDesde: item.horaDesde,
                minDesde: item.minDesde,
                horaHasta: item.horaHasta,
                minHasta: item.minHasta,
                idAlcanceFrecuencia: item.idAlcanceFrecuencia,
                idEfector: item.idEfector,
                idFrecuencia: item.idFrecuencia,
                piso: item.piso,
                recepcion: item.recepcion,
                virtual: item.idTipoTurno === 2 ? true 
                    : item.idTipoTurno === 3
                        ? true
                        : false,
                presencial: item.idTipoTurno === 1 ? true 
                    : item.idTipoTurno === 3
                        ? true
                        : false,
            }
        );

        setSelectedDays([item.dia]);
    }

    const handleNuevoRegistro = () => {
        setEditarPisoConsultorio(true);
        setBotonActualizar(false);
        const verificarEquivalencia = async () => {
            const equilvalencia = await callConParametrosTurnos(dispatch, 'RelEfectorOspe/traerPorParametros?'
                , { idEspecialidad, idCentroMedico, idProfesional }
                , 'Ha ocurrido un error por favor al cargar la equivalencia Nro Medico Ospe'
            )

            if (equilvalencia.length > 0)                        //Valido si tiene equivalencia
                doNuevoRegistro();
            else
                setOpen(true)
        }

        verificarEquivalencia();
    }

    const doNuevoRegistro = () => {
        reset(stateInitial);
        setEditRegistro(false);
        setSelectedDays(['LU', 'MA', 'MI', 'JU', 'VI']);
        dispatch(efectorHorariosUpdateDisabled(false));
    }

    const handleSubmit = () => {
        const parametros = {
            idEfector: idProfesional,
            idCentro: idCentroMedico,
            idEspecialidad: idEspecialidad,
            demanda: demanda,
            horaDesde: horaDesde,
            minDesde: minDesde,
            horaHasta: horaHasta,
            minHasta: minHasta,
            idTipoTurno: demanda ? 1 : ((presencial && virtual) ? 3 : (!virtual ? 1 : 2)),
            cantSobreTurnos: demanda ? null : cantSobreTurnos,
            idFrecuencia: idFrecuencia,
            idAlcanceFrecuencia: idAlcanceFrecuencia,
            cantDerivaciones: 0,
            duracion: demanda ? null : duracion,
            fechaInicio: fechaInicio,
            fechaFin: fechaFin,
            idEfHorario: idEfHorario,
            piso: piso,
            consultorio: consultorio,
            edadMaxima: edadMaxima,
            edadMinima: edadMinima,
            idTipoParametrizacion: TIPO_PARAMETRIZACION_TURNOS.NORMAL,
            recepcion: recepcion
        }

        dispatch(agregarEfectorHorario(parametros, selectedDays));

    }

    formValues.idProf = idProfesional;

    const cerrarModalAlta = () => setOpenAlta(false)

    const ActualizarHorarios = () => {
        const parametros = {
            idEfector: idProfesional,
            idCentro: idCentroMedico,
            idEspecialidad: idEspecialidad,
            idEfHorario: idEfHorario,
            piso: piso,
            consultorio: consultorio,
            recepcion: recepcion
        }
        dispatch(modificarPisoConsultorio(parametros));
    }
   

    return (
        <>
            <ValidatorForm onSubmit={handleSubmit} instantValidate={true}>
                <div className={classes.root}>
                    <Grid container justify="center" spacing={1}>
                        <Grid item xs={8} className={classes.grid}>
                            <Grid container direction="row" alignItems="center" spacing={1}>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboCentrosMedicos
                                            manejadorInputChange={handleInputChangeCascada}
                                            idCombo={'idCentroMedico'}
                                            filtrarPorUsuario={true}
                                            valor={idCentroMedico}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboProfesionales
                                            manejadorInputChange={handleInputChangeCascada}
                                            idCentroMedico={idCentroMedico}
                                            cargarEnCascada={true}
                                            porCentroMedico={true}
                                            valor={idProfesional}
                                            required={'required'}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <CboEspecialidades
                                            manejadorInputChange={handleInputChangeCascada}
                                            setIdEspecialidad={setIdEspecialidad}
                                            idCentroMedico={idCentroMedico}
                                            idProfesional={idProfesional}
                                            idTipoParametrizacion={TIPO_PARAMETRIZACION_TURNOS.NORMAL}
                                            cargarEnCascada={true}
                                            valor={idEspecialidad}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        <TextValidator
                                            margin="normal"
                                            label="Efector Nro"
                                            name="idProf"
                                            value={idProf}
                                            disabled={disabled}
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            fullWidth
                                            style={{ paddingRight: "0.5rem" }}
                                            type='number'
                                            required={'required'}
                                            validators={['matchRegexp:^[0-9]+$', 'isNumber']}
                                            errorMessages={['Solo se permiten números positivos enteros', 'Solo numeros']}
                                        />
                                    </Paper>
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <Paper className={classes.input}>
                                        {usuario && usuario.length > 0 ? (
                                            usuario.map(u => (
                                                <TextValidator
                                                    key={u.id} // Asegúrate de tener una clave única para cada elemento en el map
                                                    margin="normal"
                                                    label="Usuario Ospedyc"
                                                    name="u.userName"
                                                    value={u.userName}
                                                    disabled={disabled}
                                                    autoComplete="off"
                                                    //onChange={handleInputChange}
                                                    fullWidth
                                                    style={{ paddingRight: "0.5rem" }}
                                                />
                                            ))
                                        ) : (
                                            <TextValidator
                                                margin="normal"
                                                label="Usuario Ospedyc"
                                                name="u.userName"
                                                value="Sin usuario Asignado" // Valor vacío
                                                disabled={disabled}
                                                autoComplete="off"
                                                //onChange={handleInputChange}
                                                fullWidth
                                                style={{ paddingRight: "0.5rem" }}
                                            />
                                        )}
                                        {/* <BuscadorUsuarioOspe fullWith setUsuarioSel={setUsuarioSel} disabled={disabled}/> */}
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <ModalAbm title="Selección Practicas" open={openAlta} setOpen={setOpenAlta}>
                                        <ModalAgregarPracticas
                                            cerrarModal={cerrarModalAlta}
                                            idProfesional={idProfesional}
                                            idCentroMedico={idCentroMedico}
                                            idEspecialidad={idEspecialidad}
                                        />
                                    </ModalAbm>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={idEspecialidad === null}
                                        className={classes.button}
                                        onClick={() => setOpenAlta(true)}
                                    >
                                        + Agregar Practicas
                                    </Button>

                                </Grid>
                                <ModalEquilvalenciaOspe
                                    open={open}
                                    setOpen={setOpen}
                                    title={'Usuario HCE'}
                                    idProfesional={idProfesional}
                                    idCentroMedico={idCentroMedico}
                                    idEspecialidad={idEspecialidad}
                                    doNuevoRegistro={doNuevoRegistro}
                                />
                                <Grid item container justify="center">
                                    <Paper style={{ marginTop: 5 }}>
                                        <FormControl required error={errorModalidad} component="fieldset" >
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="presencial"
                                                            checked={presencial}
                                                            disabled={disabled}
                                                            onChange={(e) => setearValor(e.target.name, e.target.checked)}
                                                        />
                                                    }
                                                    label="Presencial"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="virtual"
                                                            checked={demanda ? false : virtual}
                                                            disabled={disabled || demanda}
                                                            onChange={(e) => setearValor(e.target.name, e.target.checked)}
                                                        />
                                                    }
                                                    label="Virtual"
                                                />
                                            </FormGroup>
                                            {errorModalidad &&
                                                <FormHelperText style={{ textAlign: 'center' }}>Debe incluir el Tipo de Turno </FormHelperText>
                                            }
                                        </FormControl>
                                    </Paper>
                                    <Grid item xs={12} md={1}>
                                    </Grid>
                                    <Paper style={{ marginTop: 5 }}>
                                        <FormControl required component="fieldset" >
                                            <FormGroup row>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            name="demanda"
                                                            checked={demanda}
                                                            disabled={disabled}
                                                            onChange={handleChangeDemanda}
                                                        />
                                                    }
                                                    label="Demanda"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Paper>
                                    <Grid item xs={12} md={1}>
                                    </Grid>
                                    <Paper style={{ marginTop: 5, padding: 5, display: 'flex', flexDirection: 'row' }}>
                                        <Grid item xs={12}>
                                            <TextValidator
                                                margin="normal"
                                                label="Edad Mínima"
                                                name="edadMinima"
                                                value={edadMinima}
                                                disabled={disabled || demanda}
                                                autoComplete="off"
                                                onChange={handleInputChange}
                                                fullWidth
                                                style={{ paddingRight: "0.5rem" }}
                                                type='number'
                                                validators={['matchRegexp:^[0-9]+$', 'isNumber']}
                                                errorMessages={['Solo se permiten números positivos enteros', 'Solo numeros']}
                                            />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <TextValidator
                                                margin="normal"
                                                label="Edad Máxima"
                                                name="edadMaxima"
                                                value={edadMaxima}
                                                disabled={disabled || demanda}
                                                autoComplete="off"
                                                onChange={handleInputChange}
                                                fullWidth
                                                style={{ paddingRight: "0.5rem" }}
                                                type='number'
                                                validators={['matchRegexp:^[0-9]+$', 'minNumber:1', 'isNumber']}
                                                errorMessages={['Solo se permiten números positivos enteros', 'El valor mínimo es 1', 'Solo numeros']}
                                            />
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item container justify="center">
                                    <Paper style={{ marginTop: 5 }}>
                                        <FormControl required error={errorDias} component="fieldset" >
                                            <FormGroup row>
                                                {diasSemana.map((item) => (
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                name={item.value}
                                                                checked={selectedDays.filter(w => w === item.value).length > 0 ? true : false}
                                                                onClick={() => handleClick(item)}
                                                                disabled={disabled}
                                                            />
                                                        }
                                                        label={item.display}
                                                    />
                                                ))}
                                            </FormGroup>
                                            {errorDias && !editRegistro &&
                                                <FormHelperText style={{ textAlign: 'center' }}>Debe seleccionar por lo menos un día</FormHelperText>
                                            }
                                            {errorDias && editRegistro &&
                                                <FormHelperText style={{ textAlign: 'center' }}>Al ser una modificacion se debe incluir un solo día</FormHelperText>
                                            }
                                        </FormControl>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper>
                                        <Typography style={{ textAlign: 'center', marginTop: 20 }} >Hora de Inicio</Typography>
                                        <Grid container direction="row" justify="center" spacing={1}>
                                            <Grid item xs={6}>
                                                <FormControl className={classes.formControl} required error={errorHorario} >
                                                    <SelectValidator
                                                        label="Horas"
                                                        name="horaDesde"
                                                        fullWidth={true}
                                                        value={horaDesde}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        validators={['required']}
                                                        errorMessages={['Seleccione una opción']}
                                                    >
                                                        {horas.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                    {errorHorario &&
                                                        <FormHelperText style={{ textAlign: 'center' }}>El valor no puede ser mayor a Hora Hasta </FormHelperText>
                                                    }
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl className={classes.formControl}>
                                                    <SelectValidator
                                                        label="Minutos"
                                                        name="minDesde"
                                                        fullWidth={true}
                                                        value={minDesde}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        validators={['required']}
                                                        errorMessages={['Seleccione una opción']}
                                                    >
                                                        {minutos.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper>
                                        <Typography style={{ textAlign: 'center', marginTop: 20 }} >Hora de Finalización</Typography>
                                        <Grid container direction="row" justify="center" spacing={1}>
                                            <Grid item xs={6}>
                                                <FormControl className={classes.formControl} required error={errorHorario}>
                                                    <SelectValidator
                                                        label="Horas"
                                                        name="horaHasta"
                                                        fullWidth={true}
                                                        value={horaHasta}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        validators={['required']}
                                                        errorMessages={['Seleccione una opción']}
                                                    >
                                                        {horas.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                    {errorHorario &&
                                                        <FormHelperText style={{ textAlign: 'center' }}>El valor no puede ser menor a Hora Desde </FormHelperText>
                                                    }
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <FormControl className={classes.formControl}>
                                                    <SelectValidator
                                                        label="Minutos"
                                                        name="minHasta"
                                                        fullWidth={true}
                                                        value={minHasta}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        validators={['required']}
                                                        errorMessages={['Seleccione una opción']}
                                                    >
                                                        {minutos.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <Paper>
                                        <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 15 }}>
                                            <Grid item xs={6}>
                                                <Typography style={{ textAlign: 'center' }} >Duracion Turno</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <SelectValidator
                                                        label="Minutos"
                                                        name="duracion"
                                                        fullWidth={true}
                                                        value={demanda ? null : duracion}
                                                        disabled={disabled || demanda}
                                                        onChange={handleInputChange}
                                                        validators={!demanda && ['required']}
                                                        errorMessages={!demanda && ['Seleccione una opción']}
                                                    >
                                                        {duraciones.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Typography style={{ textAlign: 'center' }} >Sobre Turnos</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <SelectValidator
                                                        label="Cantidad"
                                                        fullWidth={true}
                                                        name="cantSobreTurnos"
                                                        value={demanda ? null : cantSobreTurnos}
                                                        disabled={disabled || demanda}
                                                        onChange={handleInputChange}
                                                        validators={!demanda && ['required']}
                                                        errorMessages={!demanda && ['Seleccione una opción']}
                                                    >
                                                        {cantSobreTurnosIteracion.map((item) => (
                                                            <MenuItem value={item}>{item}</MenuItem>
                                                        ))}
                                                    </SelectValidator>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper className={classes.input}>
                                        <CboFrecuencia
                                            manejadorInputChange={handleInputChange}
                                            disabledForm={disabled}
                                            valor={idFrecuencia}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper className={classes.input}>
                                        <CboFrecuenciaAlcance
                                            manejadorInputChange={handleInputChange}
                                            disabledForm={disabled}
                                            valor={idAlcanceFrecuencia}
                                            idFrecuencia={idFrecuencia}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFechaInicio"
                                                label="Fecha Inicio"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                disabled={disabled}
                                                minDate={idEfHorario === 0 && new Date()}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                minDateMessage={`La fecha no puede ser anterior a la fecha actual`}
                                                value={
                                                    moment(fechaInicio).isValid()
                                                        ? moment(fechaInicio)
                                                        : null
                                                }
                                                onChange={(date) => {
                                                    setearValor("fechaInicio", date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <Paper>
                                        <MuiPickersUtilsProvider
                                            locale={esLocale}
                                            utils={DateFnsUtils}
                                        >
                                            <KeyboardDatePicker
                                                margin="normal"
                                                id="dialogFechaFin"
                                                label="Fecha Fin"
                                                format="dd/MM/yyyy"
                                                okLabel="Aceptar"
                                                required={true}
                                                disabled={disabled}
                                                minDate={fechaInicio}
                                                clearLabel="Limpiar"
                                                cancelLabel="Cancelar"
                                                minDateMessage={`La fecha no puede ser anterior a la fecha de inicio`}
                                                value={
                                                    moment(fechaFin).isValid()
                                                        ? moment(fechaFin)
                                                        : null
                                                }
                                                onChange={(date) => {
                                                    setearValor("fechaFin", date);
                                                }}
                                                KeyboardButtonProps={{
                                                    "aria-label": "change date",
                                                }}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Paper>
                                        <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 15 }}>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Piso</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Piso"
                                                        autoComplete="off"
                                                        name="piso"
                                                        value={piso}
                                                        disabled={!editarPisoConsultorio}
                                                        onChange={handleInputChange}
                                                        validators={["maxStringLength:4"]}
                                                        errorMessages={["Máximo 4 caracteres"]}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Consultorio</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Consultorio"
                                                        autoComplete="off"
                                                        name="consultorio"
                                                        value={consultorio}
                                                        disabled={!editarPisoConsultorio}
                                                        onChange={handleInputChange}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Recepcion</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Recepcion"
                                                        autoComplete="off"
                                                        name="recepcion"
                                                        value={recepcion}
                                                        disabled={!editarPisoConsultorio}
                                                        onChange={handleInputChange}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' }, shrink: recepcion ? true : false }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <FormControl className={classes.formControl}>
                                                    <Button
                                                        style={{ marginTop: 50, marginBottom: 5}} 
                                                        variant="contained"
                                                        color="primary"
                                                        disabled={!botonActualizar}
                                                        onClick={ActualizarHorarios}
                                                    >
                                                        Actualizar
                                                    </Button>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 20, marginBottom: 5 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={idEspecialidad === null}
                                    className={classes.button}
                                    onClick={handleSearch}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={disabled || (errorModalidad || errorDias || errorHorario)}
                                    className={classes.button}
                                    type='submit'
                                >
                                    Grabar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.ALTA) || !idCentroMedico || !idProfesional || !idEspecialidad}
                                    onClick={handleNuevoRegistro}
                                >
                                    Nuevo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.root} justify="center" spacing={1}>
                        <Grid item xs={11} className={classes.grid}>
                            <ListaParametrizacion
                                cargada={cargada}
                                permisosUser={permisosUser}
                                setSelectedDays={setSelectedDays}
                                setEditRegistro={setEditRegistro}
                                setearVariosValores={setearVariosValores}
                                setEditarPisoConsultorio={setEditarPisoConsultorio}
                                setBotonActualizar={setBotonActualizar}
                                items={[...items.filter(s => !s.inHabilitado).filter(s => moment(moment().format('YYYY-MM-DD')).isBetween(moment(s.fechaInicio).format('YYYY-MM-DD'), moment(s.fechaFin).format('YYYY-MM-DD'), undefined, '[]')), ...items.filter(s => !s.inHabilitado).filter(s => moment(moment(s.fechaInicio).format('YYYY-MM-DD')).isAfter(moment(moment().format('YYYY-MM-DD'))))]}
                                // items={items.filter(s => !s.inHabilitado)}
                                validarSoloUnPermiso={validarSoloUnPermiso}
                                handleCopyItem={handleCopyItem}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className={classes.root} justify="center" spacing={1}>
                        <Grid item xs={11} className={classes.grid}>
                            <Accordion disabled={!cargada}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography>Horarios Inactivos / Anteriores</Typography>
                                </AccordionSummary>
                                <AccordionDetails style={{ display: 'block' }}>
                                    <ListaParametrizacion
                                        setearVariosValores={setearVariosValores}
                                        setSelectedDays={setSelectedDays}
                                        setEditRegistro={setEditRegistro}
                                        validarSoloUnPermiso={validarSoloUnPermiso}
                                        setEditarPisoConsultorio={setEditarPisoConsultorio}
                                        setBotonActualizar={setBotonActualizar}
                                        items={[...items.filter(s => s.inHabilitado), ...items.filter(s => !s.inHabilitado).filter(s => moment(moment(s.fechaFin).format('YYYY-MM-DD')).isBefore(moment(moment().format('YYYY-MM-DD'))))]}
                                        // items={items.filter(s => s.inHabilitado)}
                                        handleCopyItem={handleCopyItem}
                                        permisosUser={permisosUser}
                                        cargada={cargada}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </Grid>

                </div>
            </ValidatorForm>
        </>
    );
}